import { Component, OnInit } from '@angular/core';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { QueryParamsService } from 'src/app/services/query-params.service';

@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.scss']
})
export class EmployeeListComponent implements OnInit {
  history = 0;
  permissionType = PermissionTypeEnum;

  constructor(
    private authService: AuthenticationService,
    private queryParamsService: QueryParamsService
  ) {
    var permissions = authService.getPermissions();
    if (permissions) {
      for (let i = 0; i < permissions.length; i++) {
        const element = permissions[i];
        if (element.roleId == 5017) {
          this.history = 0;
          break;
        } else if (element.roleId == 5023) {
          this.history = 1;
          break;
        } else if (element.roleId == 5018) {
          this.history = 2;
          break;
        }
      }
    }
  }

  ngOnInit(): void {
    this.history = this.queryParamsService.getNumberParam("history", 0);
  }


  updateIndexParam(value: any) {
    this.queryParamsService.setParams({
      history: value,
    });
  }
}
